export { default, StyledType, ITicketType, TYPES } from './TicketType';
